<template>
  <ErrorPageLayout pageTitle="Oops, this page no longer exists!" pageDescription="It seems that the page you’re trying to reach is no longer available." mainImage="no-page"></ErrorPageLayout>
</template>
<style scoped>
#NotFound {
  height: 100vh;
  display: grid;
  place-items: center;
}
</style>
<script>
import ErrorPageLayout from '../layouts/ErrorPageLayout.vue';
export default {
  name: 'NotFound',
  components: {
    ErrorPageLayout,
  },
};
</script>
